import { render, staticRenderFns } from "./tag.vue?vue&type=template&id=0d3e4fb6&scoped=true"
import script from "./tag.vue?vue&type=script&lang=ts"
export * from "./tag.vue?vue&type=script&lang=ts"
import style0 from "./tag.vue?vue&type=style&index=0&id=0d3e4fb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3e4fb6",
  null
  
)

export default component.exports